// extracted by mini-css-extract-plugin
module.exports = {"blockLabel":"LicenseCreate_blockLabel__2FlIV","buttonsContainer":"LicenseCreate_buttonsContainer__w2E8I"};